// Mock Users for UFF Pro Portal
export const mockUsers = [
  {
    id: 1,
    name: 'Sarah Johnson',
    email: 'sarah.johnson@uff.com',
    password: 'password123',
    role: 'LenderAdmin',
    nmls: null,
    loginType: 'Both',
    avatar: 'https://ui-avatars.com/api/?name=Sarah+Johnson'
  },
  {
    id: 2,
    name: 'Michael Chen',
    email: 'michael@primemortgage.com',
    password: 'password123',
    role: 'BrokerAdmin',
    nmls: '123456',
    brokerId: 1,
    officeId: 1,
    loginType: 'Both',
    avatar: 'https://ui-avatars.com/api/?name=Michael+Chen'
  },
  {
    id: 3,
    name: 'Jennifer Martinez',
    email: 'jennifer@primemortgage.com',
    password: 'password123',
    role: 'Broker',
    nmls: '789012',
    brokerId: 1,
    officeId: 1,
    loginType: 'Password',
    avatar: 'https://ui-avatars.com/api/?name=Jennifer+Martinez'
  },
  {
    id: 4,
    name: 'David Thompson',
    email: 'david@elitemortgage.com',
    password: 'password123',
    role: 'BrokerAdmin',
    nmls: '345678',
    brokerId: 2,
    officeId: 3,
    loginType: 'Federated',
    avatar: 'https://ui-avatars.com/api/?name=David+Thompson'
  }
];

// Mock Broker Companies
export const mockBrokers = [
  {
    id: 1,
    name: 'Prime Mortgage Solutions',
    nmls: '123456',
    compId: '',
    status: 'Active',
    dateCreated: '2024-01-15T00:00:00Z',
    website: 'https://primemortgage.com',
    address: { address1: '123 Main St', address2: 'Suite 100', city: 'Los Angeles', state: 'CA', postalCode: '90001' },
  },
  {
    id: 2,
    name: 'Elite Mortgage Group',
    nmls: '345678',
    compId: '',
    status: 'Active',
    dateCreated: '2024-02-20T00:00:00Z',
    website: 'https://elitemortgage.com',
    address: { address1: '456 Oak Ave', address2: '', city: 'Chicago', state: 'IL', postalCode: '60601' },
  },
  {
    id: 3,
    name: 'Coastal Lending Partners',
    nmls: '567890',
    compId: '',
    status: 'Disabled',
    dateCreated: '2023-11-10T00:00:00Z',
    website: 'https://coastallending.com',
    address: { address1: '789 Beach Blvd', address2: '', city: 'Miami', state: 'FL', postalCode: '33101' },
  }
];

// Mock Offices
export const mockOffices = [
  {
    id: 10,
    brokerId: 1,
    parentBrokerCompanyId: 1,
    name: 'Satellite Office - San Diego',
    nmls: '123457',
    compId: '',
    status: 'Active',
    dateCreated: '2024-03-01T00:00:00Z',
    address: { address1: '456 Harbor Dr', address2: '', city: 'San Diego', state: 'CA', postalCode: '92101' },
  },
  {
    id: 11,
    brokerId: 1,
    parentBrokerCompanyId: 1,
    name: 'Satellite Office - Sacramento',
    nmls: '123458',
    compId: '',
    status: 'Pending Approval',
    dateCreated: '2024-06-15T00:00:00Z',
    address: { address1: '100 Capitol Mall', address2: 'Suite 200', city: 'Sacramento', state: 'CA', postalCode: '95814' },
  },
  {
    id: 12,
    brokerId: 2,
    parentBrokerCompanyId: 2,
    name: 'Satellite Office - Milwaukee',
    nmls: '345679',
    compId: '',
    status: 'Active',
    dateCreated: '2024-04-10T00:00:00Z',
    address: { address1: '200 Water St', address2: '', city: 'Milwaukee', state: 'WI', postalCode: '53202' },
  }
];

// Mock compensation schedules per broker company (keyed by company id).
export const mockCompensations = {
  1: [
    { id: 'comp-1', effectiveDate: '2025-11-01', percentage: 2.5, dollarAmount: null, minDollarAmount: 1500, maxDollarAmount: 15000, isActive: true, lockdownEndDate: null },
    { id: 'comp-0', effectiveDate: '2024-06-01', percentage: 2.25, dollarAmount: null, minDollarAmount: 1000, maxDollarAmount: 12000, isActive: false, lockdownEndDate: null },
  ],
};

// Mock broker compensation change requests (ENG-256) — mutated in memory by
// the mock approve/reject handlers so the queue round-trips in mock mode.
export const mockCompRequests = [
  {
    id: 'cr-1',
    brokerCompanyId: 1,
    brokerCompanyName: 'Prime Mortgage Solutions',
    brokerCompanyNmls: '123456',
    status: 'Pending',
    currentCompensation: { percentage: 2.5, dollarAmount: null, minDollarAmount: 1500, maxDollarAmount: 15000, effectiveDate: '2025-11-01' },
    requestedCompensation: { percentage: 2.75, dollarAmount: null, minDollarAmount: 1500, maxDollarAmount: 20000 },
    requestedEffectiveDate: '2026-09-01',
    requestedByName: 'Michael Chen',
    requestedByEmail: 'michael@primemortgage.com',
    submittedDate: '2026-08-18T16:20:00Z',
    approvedEffectiveDate: null,
    decidedByName: null,
    decidedDate: null,
    rejectionReason: null,
    optimalBlueAttestation: false,
  },
  {
    id: 'cr-2',
    brokerCompanyId: 2,
    brokerCompanyName: 'Elite Mortgage Group',
    brokerCompanyNmls: '345678',
    status: 'Pending',
    currentCompensation: null,
    requestedCompensation: { percentage: 2.0, dollarAmount: null, minDollarAmount: 1000, maxDollarAmount: 10000 },
    requestedEffectiveDate: '2026-08-25',
    requestedByName: 'Sarah Williams',
    requestedByEmail: 'sarah@elitemortgage.com',
    submittedDate: '2026-08-20T09:05:00Z',
    approvedEffectiveDate: null,
    decidedByName: null,
    decidedDate: null,
    rejectionReason: null,
    optimalBlueAttestation: false,
  },
  {
    id: 'cr-3',
    brokerCompanyId: 1,
    brokerCompanyName: 'Prime Mortgage Solutions',
    brokerCompanyNmls: '123456',
    status: 'Rejected',
    currentCompensation: { percentage: 2.5, dollarAmount: null, minDollarAmount: 1500, maxDollarAmount: 15000, effectiveDate: '2025-11-01' },
    requestedCompensation: { percentage: 3.5, dollarAmount: null, minDollarAmount: 1500, maxDollarAmount: 25000 },
    requestedEffectiveDate: '2026-07-01',
    requestedByName: 'Michael Chen',
    requestedByEmail: 'michael@primemortgage.com',
    submittedDate: '2026-06-24T13:40:00Z',
    approvedEffectiveDate: null,
    decidedByName: 'Dana Ortiz',
    decidedDate: '2026-06-26T10:12:00Z',
    rejectionReason: 'Requested comp exceeds the plan cap for this tier. Please resubmit at 3% or below.',
    optimalBlueAttestation: false,
  },
];

// Mock Loans (Pipeline Data with Full Details)
export const mockLoans = [
  {
    id: 1,
    loanNumber: 'UFF-2024-001',
    borrowerName: 'John Smith',
    loanAmount: 450000,
    status: 'In Underwriting',
    lockExpiration: '2026-02-15',
    conditionsCount: 3,
    propertyAddress: '123 Oak Street, Los Angeles, CA',
    loanOfficer: 'Michael Chen',
    submittedDate: '2024-01-20',
    isRecentlyApproved: false,
    lockExpiringSoon: true,
    // URLA Section 1a — Borrower Information (MISMO 3.4 aligned)
    borrower: {
      // Personal Information
      firstName: 'John',
      middleName: 'Michael',
      lastName: 'Smith',
      suffix: '',
      email: 'john.smith@email.com',
      homePhone: '(555) 234-5678',
      cellPhone: '(555) 234-9999',
      workPhone: '(555) 234-0000',
      ssn: '***-**-1234',
      dateOfBirth: '1985-03-15',
      citizenshipType: 'USCitizen',
      maritalStatus: 'Married',
      dependentsCount: 2,
      dependentsAges: '5, 8',
      creditScore: 740,
      // Current Address (URLA Section 1a)
      currentAddress: {
        street: '456 Elm Avenue',
        unit: '',
        unitType: '',
        city: 'Burbank',
        state: 'CA',
        zip: '91502',
        country: 'US',
        residencyBasis: 'Rent',
        monthlyRent: 2800,
        moveInDate: '2025-03-01',
        yearsAtAddress: 0.9,
      },
      // Previous Address (shown when currentAddress < 2 years)
      previousAddress: {
        street: '789 Pine Street',
        unit: 'Apt 4B',
        unitType: 'Apartment',
        city: 'Glendale',
        state: 'CA',
        zip: '91201',
        country: 'US',
        residencyBasis: 'Rent',
        monthlyRent: 2200,
        moveInDate: '2021-06-15',
        moveOutDate: '2025-02-28',
        yearsAtAddress: 3.7,
      },
      // Mailing Address
      mailingAddressSameAsCurrent: true,
      mailingAddress: {
        street: '',
        unit: '',
        unitType: '',
        city: '',
        state: '',
        zip: '',
        country: 'US',
      },
      currentAddressIsSubjectProperty: false,
      // URLA Section 1b — Employment (current + previous if < 2 years)
      employmentHistory: [
        {
          id: 1,
          employerName: 'Tech Solutions Inc.',
          employerPhone: '(555) 800-1234',
          employerAddress: { street: '100 Innovation Blvd', city: 'Los Angeles', state: 'CA', zip: '90017', country: 'US' },
          position: 'Senior Software Engineer',
          startDate: '2020-07-01',
          endDate: null,
          isCurrent: true,
          classification: 'Primary',
          isSelfEmployed: false,
          ownershipShare: null,
          monthlyIncome: 12500,
          yearsInProfession: 12,
        },
        {
          id: 2,
          employerName: 'DataWorks Corp.',
          employerPhone: '(555) 700-5678',
          employerAddress: { street: '200 Tech Park Dr', city: 'Pasadena', state: 'CA', zip: '91101', country: 'US' },
          position: 'Software Engineer',
          startDate: '2016-01-15',
          endDate: '2020-06-30',
          isCurrent: false,
          classification: 'Primary',
          isSelfEmployed: false,
          ownershipShare: null,
          monthlyIncome: 9000,
          yearsInProfession: 12,
        },
      ],
      // URLA Section 1c — Other Income
      otherIncome: [
        { id: 1, incomeType: 'DividendsInterest', monthlyAmount: 350, description: 'Brokerage account dividends' },
        { id: 2, incomeType: 'Other', monthlyAmount: 1500, description: 'Annual bonus (averaged monthly)' },
      ],
    },
    additionalBorrowers: [
      {
        borrowerType: 'Spouse Co-Borrower',
        firstName: 'Jane',
        middleName: 'Marie',
        lastName: 'Smith',
        suffix: '',
        email: 'jane.smith@email.com',
        homePhone: '(555) 234-5678',
        cellPhone: '(555) 234-8888',
        workPhone: '',
        ssn: '***-**-5678',
        dateOfBirth: '1987-07-22',
        citizenshipType: 'USCitizen',
        maritalStatus: 'Married',
        dependentsCount: 2,
        dependentsAges: '5, 8',
        creditScore: 755,
        currentAddress: {
          street: '456 Elm Avenue',
          unit: '',
          unitType: '',
          city: 'Burbank',
          state: 'CA',
          zip: '91502',
          country: 'US',
          residencyBasis: 'Rent',
          monthlyRent: 0,
          moveInDate: '2025-03-01',
          yearsAtAddress: 0.9,
        },
        previousAddress: {
          street: '789 Pine Street',
          unit: 'Apt 4B',
          unitType: 'Apartment',
          city: 'Glendale',
          state: 'CA',
          zip: '91201',
          country: 'US',
          residencyBasis: 'Rent',
          monthlyRent: 0,
          moveInDate: '2021-06-15',
          moveOutDate: '2025-02-28',
          yearsAtAddress: 3.7,
        },
        mailingAddressSameAsCurrent: true,
        mailingAddress: { street: '', unit: '', unitType: '', city: '', state: '', zip: '', country: 'US' },
        currentAddressIsSubjectProperty: false,
        employmentHistory: [
          {
            id: 3,
            employerName: 'Marketing Pros LLC',
            employerPhone: '(555) 600-3456',
            employerAddress: { street: '300 Brand Blvd', city: 'Glendale', state: 'CA', zip: '91203', country: 'US' },
            position: 'Marketing Director',
            startDate: '2022-04-01',
            endDate: null,
            isCurrent: true,
            classification: 'Primary',
            isSelfEmployed: false,
            ownershipShare: null,
            monthlyIncome: 9500,
            yearsInProfession: 8,
          },
          {
            id: 4,
            employerName: 'BrandForce Agency',
            employerPhone: '(555) 600-7890',
            employerAddress: { street: '50 Sunset Blvd', city: 'Hollywood', state: 'CA', zip: '90028', country: 'US' },
            position: 'Senior Marketing Manager',
            startDate: '2018-09-01',
            endDate: '2022-03-31',
            isCurrent: false,
            classification: 'Primary',
            isSelfEmployed: false,
            ownershipShare: null,
            monthlyIncome: 7500,
            yearsInProfession: 8,
          },
        ],
        otherIncome: [
          { id: 3, incomeType: 'Rental', monthlyAmount: 800, description: 'Rental income from inherited condo' },
        ],
      },
    ],
    // Property Details
    property: {
      address: '123 Oak Street',
      city: 'Los Angeles',
      state: 'CA',
      zip: '90001',
      county: 'Los Angeles',
      propertyType: 'SingleFamily',
      occupancy: 'PrimaryResidence',
      units: 1,
      yearBuilt: 2018,
      appraisedValue: 500000,
      purchasePrice: 475000,
      estimatedValue: 500000
    },
    // Vesta: Loan-level + nested LoanProduct
    loanDetails: {
      loanPurpose: 'Purchase',
      loanAmount: 450000,
      salesContractPurchasePrice: 475000,
      downPaymentAmount: 25000,
      downPaymentPercentage: 5.26,
      loanToValueRatio: 90.0,
      combinedLoanToValueRatio: 90.0,
      mortgagePrincipalAndInterestMonthlyPayment: 2960,
      scheduledFirstPaymentDate: '2026-04-01',
      loanMaturityDate: '2056-03-01',
      estimatedClosingDate: '2026-02-28',
      loanProduct: {
        mortgageType: 'Conventional',
        programName: '30 Year Fixed',
        noteRate: 6.875,
        annualPercentageRate: 7.125,
        loanTermMonthsCount: 360,
        loanAmortizationType: 'Fixed',
        rateLockedDate: '2026-01-20',
        rateLockExpiresDate: '2026-02-20',
        rateLockStatus: 'Locked',
      },
    },
    // Assets
    assets: {
      checkingAccounts: 45000,
      savingsAccounts: 35000,
      retirement: 125000,
      other: 15000,
      total: 220000
    },
    // Liabilities
    liabilities: {
      creditCards: 8500,
      autoLoans: 22000,
      studentLoans: 15000,
      other: 0,
      total: 45500,
      monthlyDebts: 1250
    },
    // Ratios
    ratios: {
      dti: 19.2,
      housingRatio: 13.4,
      ltv: 90.0,
      cltv: 90.0
    }
  },
  {
    id: 2,
    loanNumber: 'UFF-2024-002',
    borrowerName: 'Emily Davis',
    loanAmount: 625000,
    status: 'Approved',
    lockExpiration: null,
    conditionsCount: 0,
    propertyAddress: '456 Maple Ave, San Diego, CA',
    loanOfficer: 'Michael Chen',
    submittedDate: '2024-01-18',
    isRecentlyApproved: true,
    lockExpiringSoon: false,
    borrower: {
      firstName: 'Emily',
      middleName: '',
      lastName: 'Davis',
      suffix: '',
      email: 'emily.davis@email.com',
      homePhone: '',
      cellPhone: '(555) 345-6789',
      workPhone: '(555) 345-0000',
      ssn: '***-**-2345',
      dateOfBirth: '1990-05-20',
      citizenshipType: 'USCitizen',
      maritalStatus: 'Unmarried',
      dependentsCount: 0,
      dependentsAges: '',
      creditScore: 780,
      currentAddress: {
        street: '456 Maple Ave', unit: '', unitType: '', city: 'San Diego', state: 'CA', zip: '92101', country: 'US',
        residencyBasis: 'Rent', monthlyRent: 3200, moveInDate: '2022-06-01', yearsAtAddress: 3.5,
      },
      previousAddress: null,
      mailingAddressSameAsCurrent: true,
      mailingAddress: { street: '', unit: '', unitType: '', city: '', state: '', zip: '', country: 'US' },
      currentAddressIsSubjectProperty: false,
      employmentHistory: [
        { id: 10, employerName: 'Healthcare Systems', employerPhone: '(555) 400-1000', employerAddress: { street: '500 Medical Center Dr', city: 'San Diego', state: 'CA', zip: '92103', country: 'US' }, position: 'Physician', startDate: '2023-07-01', endDate: null, isCurrent: true, classification: 'Primary', isSelfEmployed: false, ownershipShare: null, monthlyIncome: 18500, yearsInProfession: 6 },
      ],
      otherIncome: [],
    },
    additionalBorrowers: [],
    property: {
      address: '456 Maple Ave',
      city: 'San Diego',
      state: 'CA',
      zip: '92101',
      county: 'San Diego',
      propertyType: 'Condominium',
      occupancy: 'PrimaryResidence',
      units: 1,
      yearBuilt: 2020,
      appraisedValue: 650000,
      purchasePrice: 650000,
      estimatedValue: 650000
    },
    loanDetails: {
      loanPurpose: 'Purchase',
      loanAmount: 625000,
      salesContractPurchasePrice: 650000,
      downPaymentAmount: 25000,
      downPaymentPercentage: 3.85,
      loanToValueRatio: 96.15,
      combinedLoanToValueRatio: 96.15,
      mortgagePrincipalAndInterestMonthlyPayment: 4055,
      scheduledFirstPaymentDate: '2024-04-01',
      loanMaturityDate: '2054-03-01',
      estimatedClosingDate: '2024-02-25',
      loanProduct: {
        mortgageType: 'Conventional',
        programName: '30 Year Fixed',
        noteRate: 6.750,
        annualPercentageRate: 6.950,
        loanTermMonthsCount: 360,
        loanAmortizationType: 'Fixed',
        rateLockedDate: null,
        rateLockExpiresDate: null,
        rateLockStatus: 'NotLocked',
      },
    },
    assets: {
      checkingAccounts: 85000,
      savingsAccounts: 120000,
      retirement: 250000,
      other: 45000,
      total: 500000
    },
    liabilities: {
      creditCards: 3500,
      autoLoans: 0,
      studentLoans: 0,
      other: 0,
      total: 3500,
      monthlyDebts: 350
    },
    ratios: {
      dti: 23.8,
      housingRatio: 21.9,
      ltv: 96.15,
      cltv: 96.15
    }
  },
  {
    id: 3,
    loanNumber: 'UFF-2024-003',
    borrowerName: 'James Anderson',
    loanAmount: 380000,
    status: 'Conditions',
    lockExpiration: '2026-02-20',
    conditionsCount: 5,
    propertyAddress: '789 Pine Rd, Irvine, CA',
    loanOfficer: 'Jennifer Martinez',
    submittedDate: '2024-01-22',
    isRecentlyApproved: false,
    lockExpiringSoon: false,
    borrower: {
      firstName: 'James',
      middleName: 'Robert',
      lastName: 'Anderson',
      suffix: '',
      email: 'james.anderson@email.com',
      homePhone: '(555) 456-7890',
      cellPhone: '(555) 456-7892',
      workPhone: '',
      ssn: '***-**-3456',
      dateOfBirth: '1982-11-10',
      citizenshipType: 'USCitizen',
      maritalStatus: 'Married',
      dependentsCount: 3,
      dependentsAges: '4, 7, 10',
      creditScore: 695,
      currentAddress: {
        street: '100 Birch Lane', unit: '', unitType: '', city: 'Irvine', state: 'CA', zip: '92602', country: 'US',
        residencyBasis: 'Own', monthlyRent: 0, moveInDate: '2019-08-01', yearsAtAddress: 6.5,
      },
      previousAddress: null,
      mailingAddressSameAsCurrent: true,
      mailingAddress: { street: '', unit: '', unitType: '', city: '', state: '', zip: '', country: 'US' },
      currentAddressIsSubjectProperty: false,
      employmentHistory: [
        { id: 20, employerName: 'Construction Co.', employerPhone: '(555) 500-2000', employerAddress: { street: '800 Builder Way', city: 'Irvine', state: 'CA', zip: '92618', country: 'US' }, position: 'Project Manager', startDate: '2018-01-15', endDate: null, isCurrent: true, classification: 'Primary', isSelfEmployed: false, ownershipShare: null, monthlyIncome: 9200, yearsInProfession: 15 },
      ],
      otherIncome: [],
    },
    additionalBorrowers: [
      {
        borrowerType: 'Spouse Co-Borrower',
        firstName: 'Sarah',
        middleName: 'Lynn',
        lastName: 'Anderson',
        suffix: '',
        email: 'sarah.anderson@email.com',
        homePhone: '(555) 456-7890',
        cellPhone: '(555) 456-7893',
        workPhone: '',
        ssn: '***-**-7890',
        dateOfBirth: '1984-02-14',
        citizenshipType: 'USCitizen',
        maritalStatus: 'Married',
        dependentsCount: 3,
        dependentsAges: '4, 7, 10',
        creditScore: 710,
        currentAddress: {
          street: '100 Birch Lane', unit: '', unitType: '', city: 'Irvine', state: 'CA', zip: '92602', country: 'US',
          residencyBasis: 'Own', monthlyRent: 0, moveInDate: '2019-08-01', yearsAtAddress: 6.5,
        },
        previousAddress: null,
        mailingAddressSameAsCurrent: true,
        mailingAddress: { street: '', unit: '', unitType: '', city: '', state: '', zip: '', country: 'US' },
        currentAddressIsSubjectProperty: false,
        employmentHistory: [
          { id: 21, employerName: 'School District', employerPhone: '(555) 500-3000', employerAddress: { street: '200 Education Blvd', city: 'Irvine', state: 'CA', zip: '92604', country: 'US' }, position: 'Teacher', startDate: '2020-08-15', endDate: null, isCurrent: true, classification: 'Primary', isSelfEmployed: false, ownershipShare: null, monthlyIncome: 5800, yearsInProfession: 10 },
        ],
        otherIncome: [],
      },
    ],
    property: {
      address: '789 Pine Rd',
      city: 'Irvine',
      state: 'CA',
      zip: '92602',
      county: 'Orange',
      propertyType: 'SingleFamily',
      occupancy: 'PrimaryResidence',
      units: 1,
      yearBuilt: 2005,
      appraisedValue: 425000,
      purchasePrice: 400000,
      estimatedValue: 425000
    },
    loanDetails: {
      loanPurpose: 'Purchase',
      loanAmount: 380000,
      salesContractPurchasePrice: 400000,
      downPaymentAmount: 20000,
      downPaymentPercentage: 5.0,
      loanToValueRatio: 95.0,
      combinedLoanToValueRatio: 95.0,
      mortgagePrincipalAndInterestMonthlyPayment: 2401,
      scheduledFirstPaymentDate: '2024-05-01',
      loanMaturityDate: '2054-04-01',
      estimatedClosingDate: '2024-03-05',
      loanProduct: {
        mortgageType: 'FHA',
        programName: '30 Year Fixed',
        noteRate: 6.500,
        annualPercentageRate: 7.250,
        loanTermMonthsCount: 360,
        loanAmortizationType: 'Fixed',
        rateLockedDate: '2026-01-22',
        rateLockExpiresDate: '2026-02-20',
        rateLockStatus: 'Locked',
      },
    },
    assets: {
      checkingAccounts: 28000,
      savingsAccounts: 15000,
      retirement: 85000,
      other: 5000,
      total: 133000
    },
    liabilities: {
      creditCards: 12000,
      autoLoans: 28000,
      studentLoans: 22000,
      other: 0,
      total: 62000,
      monthlyDebts: 1850
    },
    ratios: {
      dti: 28.3,
      housingRatio: 16.0,
      ltv: 95.0,
      cltv: 95.0
    }
  },
  {
    id: 4,
    loanNumber: 'UFF-2024-004',
    borrowerName: 'Maria Garcia',
    loanAmount: 525000,
    status: 'Processing',
    lockExpiration: '2024-02-25',
    conditionsCount: 1,
    propertyAddress: '321 Cedar Ln, Costa Mesa, CA',
    loanOfficer: 'Michael Chen',
    submittedDate: '2024-01-25',
    isRecentlyApproved: false,
    lockExpiringSoon: false,
    borrower: {
      firstName: 'Maria',
      middleName: 'Elena',
      lastName: 'Garcia',
      suffix: '',
      email: 'maria.garcia@email.com',
      homePhone: '',
      cellPhone: '(555) 567-8901',
      workPhone: '(555) 567-0000',
      ssn: '***-**-4567',
      dateOfBirth: '1988-08-30',
      citizenshipType: 'USCitizen',
      maritalStatus: 'Unmarried',
      dependentsCount: 1,
      dependentsAges: '3',
      creditScore: 725,
      currentAddress: {
        street: '200 Harbor Blvd', unit: 'Unit 12', unitType: 'Unit', city: 'Costa Mesa', state: 'CA', zip: '92626', country: 'US',
        residencyBasis: 'Rent', monthlyRent: 2600, moveInDate: '2023-01-15', yearsAtAddress: 3.0,
      },
      previousAddress: null,
      mailingAddressSameAsCurrent: true,
      mailingAddress: { street: '', unit: '', unitType: '', city: '', state: '', zip: '', country: 'US' },
      currentAddressIsSubjectProperty: false,
      employmentHistory: [
        { id: 30, employerName: 'Financial Services Inc.', employerPhone: '(555) 600-4000', employerAddress: { street: '700 Finance Plaza', city: 'Costa Mesa', state: 'CA', zip: '92626', country: 'US' }, position: 'Financial Analyst', startDate: '2021-06-01', endDate: null, isCurrent: true, classification: 'Primary', isSelfEmployed: false, ownershipShare: null, monthlyIncome: 11000, yearsInProfession: 7 },
      ],
      otherIncome: [
        { id: 30, incomeType: 'ChildSupport', monthlyAmount: 1200, description: 'Child support received' },
      ],
    },
    additionalBorrowers: [],
    property: {
      address: '321 Cedar Ln',
      city: 'Costa Mesa',
      state: 'CA',
      zip: '92626',
      county: 'Orange',
      propertyType: 'PlannedUnitDevelopment',
      occupancy: 'PrimaryResidence',
      units: 1,
      yearBuilt: 2015,
      appraisedValue: 575000,
      purchasePrice: 550000,
      estimatedValue: 575000
    },
    loanDetails: {
      loanPurpose: 'Purchase',
      loanAmount: 525000,
      salesContractPurchasePrice: 550000,
      downPaymentAmount: 25000,
      downPaymentPercentage: 4.55,
      loanToValueRatio: 95.45,
      combinedLoanToValueRatio: 95.45,
      mortgagePrincipalAndInterestMonthlyPayment: 3380,
      scheduledFirstPaymentDate: '2024-05-01',
      loanMaturityDate: '2054-04-01',
      estimatedClosingDate: '2024-03-10',
      loanProduct: {
        mortgageType: 'Conventional',
        programName: '30 Year Fixed',
        noteRate: 6.625,
        annualPercentageRate: 6.875,
        loanTermMonthsCount: 360,
        loanAmortizationType: 'Fixed',
        rateLockedDate: '2026-01-25',
        rateLockExpiresDate: '2026-02-25',
        rateLockStatus: 'Locked',
      },
    },
    assets: {
      checkingAccounts: 55000,
      savingsAccounts: 40000,
      retirement: 145000,
      other: 20000,
      total: 260000
    },
    liabilities: {
      creditCards: 5500,
      autoLoans: 18000,
      studentLoans: 8000,
      other: 0,
      total: 31500,
      monthlyDebts: 950
    },
    ratios: {
      dti: 39.4,
      housingRatio: 30.7,
      ltv: 95.45,
      cltv: 95.45
    }
  },
  {
    id: 5,
    loanNumber: 'UFF-2024-005',
    borrowerName: 'Christopher Lee',
    loanAmount: 750000,
    status: 'Clear to Close',
    lockExpiration: '2026-02-28',
    conditionsCount: 0,
    propertyAddress: '555 Sunset Blvd, Los Angeles, CA',
    loanOfficer: 'Jennifer Martinez',
    submittedDate: '2024-01-15',
    isRecentlyApproved: false,
    lockExpiringSoon: false,
    borrower: {
      firstName: 'Christopher',
      lastName: 'Lee',
      email: 'christopher.lee@email.com',
      phone: '(555) 678-9012',
      ssn: '***-**-5678',
      dateOfBirth: '1980-12-05',
      maritalStatus: 'Married',
      dependents: 2,
      creditScore: 800,
      employment: {
        employer: 'Law Firm Partners',
        position: 'Attorney',
        yearsEmployed: 12.0,
        monthlyIncome: 25000,
        employmentType: 'W2'
      }
    },
    additionalBorrowers: [
      {
        borrowerType: 'Spouse Co-Borrower',
        firstName: 'Michelle',
        lastName: 'Lee',
        email: 'michelle.lee@email.com',
        cellPhone: '(555) 678-9013',
        homePhone: '', workPhone: '',
        ssn: '***-**-9012',
        dateOfBirth: '1983-04-18',
        citizenshipType: 'USCitizen',
        maritalStatus: 'Married',
        dependentsCount: 2, dependentsAges: '',
        creditScore: 795,
        currentAddress: { street: '', unit: '', unitType: '', city: '', state: '', zip: '', country: 'US', residencyBasis: '', monthlyRent: 0, moveInDate: '', yearsAtAddress: null },
        previousAddress: null,
        mailingAddressSameAsCurrent: true,
        mailingAddress: { street: '', unit: '', unitType: '', city: '', state: '', zip: '', country: 'US' },
        currentAddressIsSubjectProperty: false,
        employmentHistory: [
          { id: 30, employerName: 'Design Studio', employerPhone: '', employerAddress: { street: '', city: '', state: '', zip: '', country: 'US' }, position: 'Creative Director', startDate: '2017-01-01', endDate: null, isCurrent: true, classification: 'Primary', isSelfEmployed: false, ownershipShare: null, monthlyIncome: 15000, yearsInProfession: 9 },
        ],
        otherIncome: [],
      },
    ],
    property: {
      address: '555 Sunset Blvd',
      city: 'Los Angeles',
      state: 'CA',
      zip: '90028',
      county: 'Los Angeles',
      propertyType: 'SingleFamily',
      occupancy: 'PrimaryResidence',
      units: 1,
      yearBuilt: 2022,
      appraisedValue: 950000,
      purchasePrice: 900000,
      estimatedValue: 950000
    },
    loanDetails: {
      loanPurpose: 'Purchase',
      loanAmount: 750000,
      salesContractPurchasePrice: 900000,
      downPaymentAmount: 150000,
      downPaymentPercentage: 16.67,
      loanToValueRatio: 83.33,
      combinedLoanToValueRatio: 83.33,
      mortgagePrincipalAndInterestMonthlyPayment: 4675,
      scheduledFirstPaymentDate: '2024-04-01',
      loanMaturityDate: '2054-03-01',
      estimatedClosingDate: '2024-02-20',
      loanProduct: {
        mortgageType: 'Conventional',
        programName: '30 Year Fixed',
        noteRate: 6.375,
        annualPercentageRate: 6.550,
        loanTermMonthsCount: 360,
        loanAmortizationType: 'Fixed',
        rateLockedDate: '2026-01-15',
        rateLockExpiresDate: '2026-02-28',
        rateLockStatus: 'Locked',
      },
    },
    assets: {
      checkingAccounts: 180000,
      savingsAccounts: 250000,
      retirement: 850000,
      other: 120000,
      total: 1400000
    },
    liabilities: {
      creditCards: 2500,
      autoLoans: 0,
      studentLoans: 0,
      other: 0,
      total: 2500,
      monthlyDebts: 250
    },
    ratios: {
      dti: 12.3,
      housingRatio: 11.7,
      ltv: 83.33,
      cltv: 83.33
    }
  },
  {
    id: 6,
    loanNumber: 'UFF-2024-006',
    borrowerName: 'Robert Williams',
    loanAmount: 385000,
    status: 'Processing',
    lockExpiration: null,
    conditionsCount: 2,
    propertyAddress: '456 Maple Drive, Pasadena, CA',
    loanOfficer: 'Jennifer Martinez',
    submittedDate: '2024-01-25',
    isRecentlyApproved: false,
    lockExpiringSoon: false,
    // Borrower Details
    borrower: {
      firstName: 'Robert',
      lastName: 'Williams',
      email: 'robert.williams@email.com',
      phone: '(555) 876-5432',
      ssn: '***-**-9876',
      dateOfBirth: '1982-11-08',
      maritalStatus: 'Single',
      dependents: 1,
      creditScore: 715,
      employment: {
        employer: 'Design Studio Co.',
        position: 'Creative Director',
        yearsEmployed: 8.0,
        monthlyIncome: 11000,
        employmentType: 'W2'
      }
    },
    additionalBorrowers: [],
    // Property Details
    property: {
      address: '456 Maple Drive',
      city: 'Pasadena',
      state: 'CA',
      zip: '91101',
      county: 'Los Angeles',
      propertyType: 'Condominium',
      occupancy: 'PrimaryResidence',
      units: 1,
      yearBuilt: 2015,
      appraisedValue: 410000,
      purchasePrice: 400000,
      estimatedValue: 410000
    },
    // Loan Details
    loanDetails: {
      loanPurpose: 'Purchase',
      loanAmount: 385000,
      salesContractPurchasePrice: 400000,
      downPaymentAmount: 15000,
      downPaymentPercentage: 3.75,
      loanToValueRatio: 96.25,
      combinedLoanToValueRatio: 96.25,
      mortgagePrincipalAndInterestMonthlyPayment: 2590,
      scheduledFirstPaymentDate: '2024-05-01',
      loanMaturityDate: '2054-04-01',
      estimatedClosingDate: '2024-03-10',
      loanProduct: {
        mortgageType: 'Conventional',
        programName: '30 Year Fixed',
        noteRate: 7.125,
        annualPercentageRate: 7.375,
        loanTermMonthsCount: 360,
        loanAmortizationType: 'Fixed',
        rateLockedDate: null,
        rateLockExpiresDate: null,
        rateLockStatus: 'NotLocked',
      },
    },
    // Assets
    assets: {
      checkingAccounts: 28000,
      savingsAccounts: 22000,
      retirement: 85000,
      other: 5000,
      total: 140000
    },
    // Liabilities
    liabilities: {
      creditCards: 4500,
      autoLoans: 18000,
      studentLoans: 12000,
      other: 2000,
      total: 36500,
      monthlyDebts: 850
    },
    ratios: {
      dti: 31.3,
      housingRatio: 23.5,
      ltv: 96.25,
      cltv: 96.25
    }
  }
];

// Document Types (Standard Categories)
export const documentTypes = [
  { value: 'w2', label: 'W-2 Form', category: 'Income' },
  { value: 'paystub', label: 'Pay Stub', category: 'Income' },
  { value: 'tax_return', label: 'Tax Return', category: 'Income' },
  { value: '1099', label: '1099 Form', category: 'Income' },
  { value: 'bank_statement', label: 'Bank Statement', category: 'Assets' },
  { value: 'investment_statement', label: 'Investment Statement', category: 'Assets' },
  { value: 'retirement_statement', label: 'Retirement Account Statement', category: 'Assets' },
  { value: 'drivers_license', label: 'Driver\'s License', category: 'Identification' },
  { value: 'passport', label: 'Passport', category: 'Identification' },
  { value: 'ssn_card', label: 'Social Security Card', category: 'Identification' },
  { value: 'credit_report', label: 'Credit Report', category: 'Credit' },
  { value: 'employment_verification', label: 'Employment Verification', category: 'Employment' },
  { value: 'offer_letter', label: 'Offer Letter', category: 'Employment' },
  { value: 'appraisal', label: 'Appraisal Report', category: 'Property' },
  { value: 'home_insurance', label: 'Homeowners Insurance', category: 'Property' },
  { value: 'purchase_agreement', label: 'Purchase Agreement', category: 'Property' },
  { value: 'title_report', label: 'Title Report', category: 'Property' },
  { value: 'divorce_decree', label: 'Divorce Decree', category: 'Legal' },
  { value: 'bankruptcy_discharge', label: 'Bankruptcy Discharge', category: 'Legal' },
  { value: 'authorization', label: 'Authorization Form', category: 'Disclosures' },
  { value: 'disclosure', label: 'Disclosure Document', category: 'Disclosures' },
  { value: 'other', label: 'Other', category: 'Other' }
];

// Mock Documents (for loan 1)
export const mockDocuments = [
  {
    id: 1,
    loanId: 1,
    fileName: '2023_W2_John_Smith.pdf',
    fileSize: 245000,
    documentType: 'w2',
    uploadedBy: 'Michael Chen',
    uploadedByType: 'broker',
    uploadedDate: '2024-01-21T10:30:00',
    conditionId: 1,
    status: 'approved',
    aiSuggestions: {
      suggestedType: 'w2',
      confidence: 0.98,
      flags: []
    },
    notes: 'Most recent W-2 for primary borrower'
  },
  {
    id: 2,
    loanId: 1,
    fileName: 'Paystub_Jan_2024.pdf',
    fileSize: 128000,
    documentType: 'paystub',
    uploadedBy: 'John Smith',
    uploadedByType: 'borrower',
    uploadedDate: '2024-01-22T14:15:00',
    conditionId: 2,
    status: 'pending',
    aiSuggestions: {
      suggestedType: 'paystub',
      confidence: 0.95,
      flags: ['missing_page_2']
    },
    notes: null
  },
  {
    id: 3,
    loanId: 1,
    fileName: 'Bank_Statement_Dec_2023.pdf',
    fileSize: 512000,
    documentType: 'bank_statement',
    uploadedBy: 'John Smith',
    uploadedByType: 'borrower',
    uploadedDate: '2024-01-23T09:45:00',
    conditionId: 3,
    status: 'submitted',
    aiSuggestions: {
      suggestedType: 'bank_statement',
      confidence: 0.92,
      flags: []
    },
    notes: 'Chase checking account'
  },
  {
    id: 4,
    loanId: 1,
    fileName: 'Drivers_License_Front.jpg',
    fileSize: 1024000,
    documentType: 'drivers_license',
    uploadedBy: 'Michael Chen',
    uploadedByType: 'broker',
    uploadedDate: '2024-01-20T16:20:00',
    conditionId: null,
    status: 'approved',
    aiSuggestions: {
      suggestedType: 'drivers_license',
      confidence: 0.99,
      flags: []
    },
    notes: 'ID verification complete'
  },
  {
    id: 5,
    loanId: 1,
    fileName: 'Home_Insurance_Quote.pdf',
    fileSize: 89000,
    documentType: 'home_insurance',
    uploadedBy: 'Jennifer Martinez',
    uploadedByType: 'broker',
    uploadedDate: '2024-01-24T11:00:00',
    conditionId: 5,
    status: 'rejected',
    aiSuggestions: {
      suggestedType: 'home_insurance',
      confidence: 0.88,
      flags: ['quote_not_policy']
    },
    notes: 'Need actual policy, not quote'
  },
  {
    id: 6,
    loanId: 1,
    fileName: 'SSA_89_Authorization_Signed.pdf',
    fileSize: 156000,
    documentType: 'authorization',
    uploadedBy: 'John Smith',
    uploadedByType: 'borrower',
    uploadedDate: '2024-01-25T13:30:00',
    conditionId: null,
    status: 'approved',
    aiSuggestions: {
      suggestedType: 'authorization',
      confidence: 0.97,
      flags: []
    },
    notes: 'eSigned via DocuSign',
    eSignStatus: 'signed',
    eSignedDate: '2024-01-25T13:28:00'
  }
];

// Mock Underwriting Conditions (LOS-Driven)
export const mockConditions = [
  {
    id: 1,
    loanId: 1,
    title: 'Most Recent W-2',
    description: 'Provide most recent W-2 form for primary borrower showing year-to-date income',
    assignedTo: 'broker',
    status: 'satisfied',
    priority: 'high',
    dueDate: '2024-01-25',
    createdDate: '2024-01-20T08:00:00',
    submittedDate: '2024-01-21T10:35:00',
    satisfiedDate: '2024-01-21T15:20:00',
    attachedDocuments: [1],
    submissionNotes: 'W-2 uploaded for John Smith',
    history: [
      { date: '2024-01-20T08:00:00', action: 'created', user: 'System', note: 'Condition created by underwriter' },
      { date: '2024-01-21T10:35:00', action: 'submitted', user: 'Michael Chen', note: 'W-2 document attached' },
      { date: '2024-01-21T15:20:00', action: 'satisfied', user: 'Sarah Mitchell (UW)', note: 'Approved - income verified' }
    ]
  },
  {
    id: 2,
    loanId: 1,
    title: 'Recent Pay Stubs (2 months)',
    description: 'Provide two most recent consecutive pay stubs showing year-to-date earnings',
    assignedTo: 'borrower',
    status: 'submitted',
    priority: 'high',
    dueDate: '2024-01-26',
    createdDate: '2024-01-20T08:00:00',
    submittedDate: '2024-01-22T14:20:00',
    satisfiedDate: null,
    attachedDocuments: [2],
    submissionNotes: 'January paystub uploaded, December still needed',
    history: [
      { date: '2024-01-20T08:00:00', action: 'created', user: 'System', note: 'Condition created by underwriter' },
      { date: '2024-01-22T14:20:00', action: 'submitted', user: 'John Smith (Borrower)', note: 'Uploaded January paystub' }
    ]
  },
  {
    id: 3,
    loanId: 1,
    title: 'Bank Statements (2 months)',
    description: 'Provide two most recent consecutive months of bank statements for all accounts listed on application',
    assignedTo: 'borrower',
    status: 'submitted',
    priority: 'medium',
    dueDate: '2024-01-28',
    createdDate: '2024-01-20T08:00:00',
    submittedDate: '2024-01-23T09:50:00',
    satisfiedDate: null,
    attachedDocuments: [3],
    submissionNotes: 'December statement uploaded',
    history: [
      { date: '2024-01-20T08:00:00', action: 'created', user: 'System', note: 'Condition created by underwriter' },
      { date: '2024-01-23T09:50:00', action: 'submitted', user: 'John Smith (Borrower)', note: 'Uploaded December bank statement' }
    ]
  },
  {
    id: 4,
    loanId: 1,
    title: 'Employment Verification',
    description: 'Written verification of employment (VOE) from current employer on company letterhead',
    assignedTo: 'broker',
    status: 'open',
    priority: 'high',
    dueDate: '2024-01-30',
    createdDate: '2024-01-20T08:00:00',
    submittedDate: null,
    satisfiedDate: null,
    attachedDocuments: [],
    submissionNotes: null,
    history: [
      { date: '2024-01-20T08:00:00', action: 'created', user: 'System', note: 'Condition created by underwriter' }
    ]
  },
  {
    id: 5,
    loanId: 1,
    title: 'Homeowners Insurance Policy',
    description: 'Provide proof of homeowners insurance with lender named as mortgagee',
    assignedTo: 'broker',
    status: 'rejected',
    priority: 'high',
    dueDate: '2024-01-27',
    createdDate: '2024-01-20T08:00:00',
    submittedDate: '2024-01-24T11:05:00',
    satisfiedDate: null,
    rejectedDate: '2024-01-24T16:30:00',
    attachedDocuments: [5],
    submissionNotes: 'Insurance quote attached',
    rejectionReason: 'Quote provided instead of actual policy. Need binder or policy with lender listed as mortgagee.',
    history: [
      { date: '2024-01-20T08:00:00', action: 'created', user: 'System', note: 'Condition created by underwriter' },
      { date: '2024-01-24T11:05:00', action: 'submitted', user: 'Jennifer Martinez', note: 'Insurance quote uploaded' },
      { date: '2024-01-24T16:30:00', action: 'rejected', user: 'Sarah Mitchell (UW)', note: 'Quote not acceptable - need actual policy' }
    ]
  },
  {
    id: 6,
    loanId: 1,
    title: 'Appraisal Review',
    description: 'Appraisal report must be reviewed and approved by underwriter',
    assignedTo: 'broker',
    status: 'open',
    priority: 'medium',
    dueDate: '2024-02-05',
    createdDate: '2024-01-22T10:00:00',
    submittedDate: null,
    satisfiedDate: null,
    attachedDocuments: [],
    submissionNotes: null,
    history: [
      { date: '2024-01-22T10:00:00', action: 'created', user: 'System', note: 'Condition created - appraisal ordered' }
    ]
  }
];

// Mock Activity Timeline
export const mockActivities = [
  {
    id: 1,
    loanId: 1,
    type: 'loan_created',
    timestamp: '2024-01-20T08:00:00',
    user: 'Michael Chen',
    userType: 'broker',
    description: 'Loan application created',
    metadata: { loanNumber: 'UFF-2024-001' }
  },
  {
    id: 2,
    loanId: 1,
    type: 'condition_created',
    timestamp: '2024-01-20T08:00:00',
    user: 'System',
    userType: 'system',
    description: '6 underwriting conditions created',
    metadata: { conditionCount: 6 }
  },
  {
    id: 3,
    loanId: 1,
    type: 'document_uploaded',
    timestamp: '2024-01-20T16:20:00',
    user: 'Michael Chen',
    userType: 'broker',
    description: 'Uploaded document: Drivers_License_Front.jpg',
    metadata: { documentId: 4, documentType: 'drivers_license' }
  },
  {
    id: 4,
    loanId: 1,
    type: 'document_uploaded',
    timestamp: '2024-01-21T10:30:00',
    user: 'Michael Chen',
    userType: 'broker',
    description: 'Uploaded document: 2023_W2_John_Smith.pdf',
    metadata: { documentId: 1, documentType: 'w2' }
  },
  {
    id: 5,
    loanId: 1,
    type: 'condition_submitted',
    timestamp: '2024-01-21T10:35:00',
    user: 'Michael Chen',
    userType: 'broker',
    description: 'Submitted condition: Most Recent W-2',
    metadata: { conditionId: 1 }
  },
  {
    id: 6,
    loanId: 1,
    type: 'condition_satisfied',
    timestamp: '2024-01-21T15:20:00',
    user: 'Sarah Mitchell',
    userType: 'underwriter',
    description: 'Approved condition: Most Recent W-2',
    metadata: { conditionId: 1 }
  },
  {
    id: 7,
    loanId: 1,
    type: 'document_uploaded',
    timestamp: '2024-01-22T14:15:00',
    user: 'John Smith',
    userType: 'borrower',
    description: 'Borrower uploaded: Paystub_Jan_2024.pdf',
    metadata: { documentId: 2, documentType: 'paystub' }
  },
  {
    id: 8,
    loanId: 1,
    type: 'ai_suggestion',
    timestamp: '2024-01-22T14:15:30',
    user: 'AI Assistant',
    userType: 'system',
    description: 'AI flagged: Document may be missing page 2',
    metadata: { documentId: 2, flag: 'missing_page_2' }
  },
  {
    id: 9,
    loanId: 1,
    type: 'condition_submitted',
    timestamp: '2024-01-22T14:20:00',
    user: 'John Smith',
    userType: 'borrower',
    description: 'Borrower submitted condition: Recent Pay Stubs',
    metadata: { conditionId: 2 }
  },
  {
    id: 10,
    loanId: 1,
    type: 'condition_created',
    timestamp: '2024-01-22T10:00:00',
    user: 'System',
    userType: 'system',
    description: 'New condition added: Appraisal Review',
    metadata: { conditionId: 6 }
  },
  {
    id: 11,
    loanId: 1,
    type: 'document_uploaded',
    timestamp: '2024-01-23T09:45:00',
    user: 'John Smith',
    userType: 'borrower',
    description: 'Borrower uploaded: Bank_Statement_Dec_2023.pdf',
    metadata: { documentId: 3, documentType: 'bank_statement' }
  },
  {
    id: 12,
    loanId: 1,
    type: 'condition_submitted',
    timestamp: '2024-01-23T09:50:00',
    user: 'John Smith',
    userType: 'borrower',
    description: 'Borrower submitted condition: Bank Statements',
    metadata: { conditionId: 3 }
  },
  {
    id: 13,
    loanId: 1,
    type: 'document_uploaded',
    timestamp: '2024-01-24T11:00:00',
    user: 'Jennifer Martinez',
    userType: 'broker',
    description: 'Uploaded document: Home_Insurance_Quote.pdf',
    metadata: { documentId: 5, documentType: 'home_insurance' }
  },
  {
    id: 14,
    loanId: 1,
    type: 'condition_submitted',
    timestamp: '2024-01-24T11:05:00',
    user: 'Jennifer Martinez',
    userType: 'broker',
    description: 'Submitted condition: Homeowners Insurance Policy',
    metadata: { conditionId: 5 }
  },
  {
    id: 15,
    loanId: 1,
    type: 'condition_rejected',
    timestamp: '2024-01-24T16:30:00',
    user: 'Sarah Mitchell',
    userType: 'underwriter',
    description: 'Rejected condition: Homeowners Insurance Policy - Quote not acceptable',
    metadata: { conditionId: 5, reason: 'Quote provided instead of actual policy' }
  },
  {
    id: 16,
    loanId: 1,
    type: 'esign_sent',
    timestamp: '2024-01-25T10:00:00',
    user: 'Michael Chen',
    userType: 'broker',
    description: 'eSign request sent: SSA-89 Authorization',
    metadata: { documentName: 'SSA_89_Authorization.pdf', recipient: 'John Smith' }
  },
  {
    id: 17,
    loanId: 1,
    type: 'esign_viewed',
    timestamp: '2024-01-25T13:15:00',
    user: 'John Smith',
    userType: 'borrower',
    description: 'Borrower viewed eSign document',
    metadata: { documentName: 'SSA_89_Authorization.pdf' }
  },
  {
    id: 18,
    loanId: 1,
    type: 'esign_signed',
    timestamp: '2024-01-25T13:28:00',
    user: 'John Smith',
    userType: 'borrower',
    description: 'Borrower signed document: SSA-89 Authorization',
    metadata: { documentId: 6, documentName: 'SSA_89_Authorization.pdf' }
  },
  {
    id: 19,
    loanId: 1,
    type: 'document_uploaded',
    timestamp: '2024-01-25T13:30:00',
    user: 'System',
    userType: 'system',
    description: 'Signed document automatically uploaded',
    metadata: { documentId: 6, documentType: 'authorization' }
  },
  {
    id: 20,
    loanId: 1,
    type: 'borrower_link_generated',
    timestamp: '2024-01-26T09:00:00',
    user: 'Michael Chen',
    userType: 'broker',
    description: 'Generated borrower upload link',
    metadata: { expiresAt: '2024-02-26T09:00:00' }
  }
];

// Loan Programs (Available for Pricing)
export const loanPrograms = [
  {
    id: 1,
    name: '30-Year Fixed Conventional',
    loanType: 'Conventional',
    term: 360,
    amortizationType: 'Fixed',
    minCreditScore: 620,
    maxLTV: 97,
    minDownPayment: 3,
    pmiRequired: true,
    description: 'Traditional 30-year fixed-rate mortgage with stable payments'
  },
  {
    id: 2,
    name: '20-Year Fixed Conventional',
    loanType: 'Conventional',
    term: 240,
    amortizationType: 'Fixed',
    minCreditScore: 620,
    maxLTV: 95,
    minDownPayment: 5,
    pmiRequired: true,
    description: 'Shorter term with lower total interest paid'
  },
  {
    id: 3,
    name: '15-Year Fixed Conventional',
    loanType: 'Conventional',
    term: 180,
    amortizationType: 'Fixed',
    minCreditScore: 620,
    maxLTV: 95,
    minDownPayment: 5,
    pmiRequired: true,
    description: 'Build equity faster with significantly lower interest costs'
  },
  {
    id: 4,
    name: '30-Year Fixed FHA',
    loanType: 'FHA',
    term: 360,
    amortizationType: 'Fixed',
    minCreditScore: 580,
    maxLTV: 96.5,
    minDownPayment: 3.5,
    pmiRequired: true,
    description: 'Government-backed loan with lower credit requirements'
  },
  {
    id: 5,
    name: '30-Year Fixed VA',
    loanType: 'VA',
    term: 360,
    amortizationType: 'Fixed',
    minCreditScore: 580,
    maxLTV: 100,
    minDownPayment: 0,
    pmiRequired: false,
    description: 'No down payment required for eligible veterans'
  },
  {
    id: 6,
    name: '5/1 ARM Conventional',
    loanType: 'Conventional',
    term: 360,
    amortizationType: 'ARM',
    fixedPeriod: 60,
    minCreditScore: 640,
    maxLTV: 95,
    minDownPayment: 5,
    pmiRequired: true,
    description: 'Fixed rate for 5 years, then adjusts annually'
  },
  {
    id: 7,
    name: '7/1 ARM Conventional',
    loanType: 'Conventional',
    term: 360,
    amortizationType: 'ARM',
    fixedPeriod: 84,
    minCreditScore: 640,
    maxLTV: 95,
    minDownPayment: 5,
    pmiRequired: true,
    description: 'Fixed rate for 7 years, then adjusts annually'
  },
  {
    id: 8,
    name: '30-Year Fixed Jumbo',
    loanType: 'Jumbo',
    term: 360,
    amortizationType: 'Fixed',
    minCreditScore: 700,
    maxLTV: 90,
    minDownPayment: 10,
    pmiRequired: false,
    description: 'For loan amounts exceeding conforming limits'
  }
];

// Mock Pricing Scenarios (for loan 1)
export const mockPricingScenarios = [
  {
    id: 1,
    loanId: 1,
    scenarioName: 'Current Program',
    programId: 1,
    programName: '30-Year Fixed Conventional',
    loanAmount: 450000,
    interestRate: 6.875,
    apr: 7.125,
    monthlyPayment: 2960,
    totalInterest: 615600,
    closingCosts: 8500,
    points: 0,
    credits: 0,
    pmi: 225,
    createdDate: '2024-01-20T08:00:00',
    createdBy: 'Michael Chen',
    isSelected: true,
    isPriced: true,
    pricingDetails: {
      baseRate: 6.750,
      adjustments: [
        { description: 'Credit Score 740', adjustment: 0.000 },
        { description: 'LTV 90%', adjustment: 0.125 },
        { description: 'Property Type - Single Family', adjustment: 0.000 },
        { description: 'Occupancy - Primary', adjustment: 0.000 }
      ],
      finalRate: 6.875,
      lockPeriod: 30,
      expirationDate: '2024-02-15'
    }
  },
  {
    id: 2,
    loanId: 1,
    scenarioName: '15-Year Lower Rate',
    programId: 3,
    programName: '15-Year Fixed Conventional',
    loanAmount: 450000,
    interestRate: 6.250,
    apr: 6.475,
    monthlyPayment: 3850,
    totalInterest: 243000,
    closingCosts: 8500,
    points: 0,
    credits: 0,
    pmi: 225,
    createdDate: '2024-01-22T10:30:00',
    createdBy: 'Michael Chen',
    isSelected: false,
    isPriced: true,
    pricingDetails: {
      baseRate: 6.125,
      adjustments: [
        { description: 'Credit Score 740', adjustment: 0.000 },
        { description: 'LTV 90%', adjustment: 0.125 },
        { description: 'Property Type - Single Family', adjustment: 0.000 },
        { description: 'Occupancy - Primary', adjustment: 0.000 }
      ],
      finalRate: 6.250,
      lockPeriod: null,
      expirationDate: null
    }
  },
  {
    id: 3,
    loanId: 1,
    scenarioName: 'Buy Down with Points',
    programId: 1,
    programName: '30-Year Fixed Conventional',
    loanAmount: 450000,
    interestRate: 6.625,
    apr: 6.925,
    monthlyPayment: 2885,
    totalInterest: 589600,
    closingCosts: 8500,
    points: 2.0,
    pointsCost: 9000,
    credits: 0,
    pmi: 225,
    createdDate: '2024-01-22T11:00:00',
    createdBy: 'Michael Chen',
    isSelected: false,
    isPriced: true,
    pricingDetails: {
      baseRate: 6.750,
      adjustments: [
        { description: 'Credit Score 740', adjustment: 0.000 },
        { description: 'LTV 90%', adjustment: 0.125 },
        { description: 'Property Type - Single Family', adjustment: 0.000 },
        { description: 'Occupancy - Primary', adjustment: 0.000 },
        { description: '2.0 Discount Points', adjustment: -0.250 }
      ],
      finalRate: 6.625,
      lockPeriod: null,
      expirationDate: null
    }
  },
  {
    id: 4,
    loanId: 1,
    scenarioName: '5/1 ARM Lower Start',
    programId: 6,
    programName: '5/1 ARM Conventional',
    loanAmount: 450000,
    interestRate: 6.375,
    apr: 6.825,
    monthlyPayment: 2805,
    totalInterest: 560800,
    closingCosts: 8500,
    points: 0,
    credits: 0,
    pmi: 225,
    createdDate: '2024-01-23T09:15:00',
    createdBy: 'Jennifer Martinez',
    isSelected: false,
    isPriced: true,
    pricingDetails: {
      baseRate: 6.250,
      adjustments: [
        { description: 'Credit Score 740', adjustment: 0.000 },
        { description: 'LTV 90%', adjustment: 0.125 },
        { description: 'Property Type - Single Family', adjustment: 0.000 },
        { description: 'Occupancy - Primary', adjustment: 0.000 }
      ],
      finalRate: 6.375,
      lockPeriod: null,
      expirationDate: null,
      armDetails: {
        initialFixedPeriod: 60,
        adjustmentFrequency: 12,
        initialCap: 2.0,
        periodicCap: 2.0,
        lifetimeCap: 5.0,
        index: 'SOFR',
        margin: 2.75
      }
    }
  }
];

// Rate Sheet (Current Market Rates)
export const mockRateSheet = {
  effectiveDate: '2024-01-26T08:00:00',
  expirationDate: '2024-01-26T17:00:00',
  programs: [
    {
      programId: 1,
      programName: '30-Year Fixed Conventional',
      rates: [
        { rate: 6.625, points: 2.000, apr: 6.925, price: 98.000 },
        { rate: 6.750, points: 1.000, apr: 7.025, price: 99.000 },
        { rate: 6.875, points: 0.000, apr: 7.125, price: 100.000 },
        { rate: 7.000, points: -0.500, apr: 7.225, price: 100.500 },
        { rate: 7.125, points: -1.000, apr: 7.325, price: 101.000 }
      ]
    },
    {
      programId: 3,
      programName: '15-Year Fixed Conventional',
      rates: [
        { rate: 6.000, points: 2.000, apr: 6.275, price: 98.000 },
        { rate: 6.125, points: 1.000, apr: 6.375, price: 99.000 },
        { rate: 6.250, points: 0.000, apr: 6.475, price: 100.000 },
        { rate: 6.375, points: -0.500, apr: 6.575, price: 100.500 },
        { rate: 6.500, points: -1.000, apr: 6.675, price: 101.000 }
      ]
    },
    {
      programId: 4,
      programName: '30-Year Fixed FHA',
      rates: [
        { rate: 6.500, points: 2.000, apr: 6.825, price: 98.000 },
        { rate: 6.625, points: 1.000, apr: 6.925, price: 99.000 },
        { rate: 6.750, points: 0.000, apr: 7.025, price: 100.000 },
        { rate: 6.875, points: -0.500, apr: 7.125, price: 100.500 },
        { rate: 7.000, points: -1.000, apr: 7.225, price: 101.000 }
      ]
    },
    {
      programId: 6,
      programName: '5/1 ARM Conventional',
      rates: [
        { rate: 6.125, points: 2.000, apr: 6.625, price: 98.000 },
        { rate: 6.250, points: 1.000, apr: 6.725, price: 99.000 },
        { rate: 6.375, points: 0.000, apr: 6.825, price: 100.000 },
        { rate: 6.500, points: -0.500, apr: 6.925, price: 100.500 },
        { rate: 6.625, points: -1.000, apr: 7.025, price: 101.000 }
      ]
    }
  ],
  adjustments: {
    creditScore: [
      { min: 760, max: 850, adjustment: -0.125 },
      { min: 740, max: 759, adjustment: 0.000 },
      { min: 720, max: 739, adjustment: 0.125 },
      { min: 700, max: 719, adjustment: 0.250 },
      { min: 680, max: 699, adjustment: 0.375 },
      { min: 660, max: 679, adjustment: 0.500 },
      { min: 640, max: 659, adjustment: 0.750 },
      { min: 620, max: 639, adjustment: 1.000 }
    ],
    ltv: [
      { min: 0, max: 60, adjustment: -0.250 },
      { min: 60.01, max: 70, adjustment: -0.125 },
      { min: 70.01, max: 80, adjustment: 0.000 },
      { min: 80.01, max: 85, adjustment: 0.125 },
      { min: 85.01, max: 90, adjustment: 0.250 },
      { min: 90.01, max: 95, adjustment: 0.375 },
      { min: 95.01, max: 97, adjustment: 0.500 }
    ],
    propertyType: [
      { type: 'SingleFamily', adjustment: 0.000 },
      { type: 'Condominium', adjustment: 0.125 },
      { type: 'PlannedUnitDevelopment', adjustment: 0.125 },
      { type: 'TwoToFourUnitProperty', adjustment: 0.250 },
      { type: 'ManufacturedHome', adjustment: 0.500 }
    ],
    occupancy: [
      { type: 'PrimaryResidence', adjustment: 0.000 },
      { type: 'SecondHome', adjustment: 0.375 },
      { type: 'Investment', adjustment: 0.750 }
    ],
    cashOut: [
      { type: 'No Cash Out', adjustment: 0.000 },
      { type: 'Cash Out', adjustment: 0.375 }
    ]
  }
};

// Lock History (for tracking rate locks)
export const mockLockHistory = [
  {
    id: 1,
    loanId: 1,
    scenarioId: 1,
    lockedRate: 6.875,
    lockDate: '2024-01-20T14:30:00',
    lockPeriod: 30,
    expirationDate: '2024-02-15',
    lockedBy: 'Michael Chen',
    status: 'active',
    lockConfirmation: 'LOCK-2024-001-ABC123',
    notes: 'Initial rate lock at borrower request'
  }
];

// Chat Messages (Broker ↔ Lender Communication)
export const mockChatMessages = [
  {
    id: 1,
    loanId: 1,
    threadId: 'general',
    messageType: 'user',
    senderType: 'broker',
    senderId: 2,
    senderName: 'Michael Chen',
    senderAvatar: 'MC',
    message: 'Hi team, I wanted to check on the status of this loan. The borrower is asking for an update.',
    timestamp: '2024-01-20T09:15:00',
    isRead: true,
    attachments: []
  },
  {
    id: 2,
    loanId: 1,
    threadId: 'general',
    messageType: 'user',
    senderType: 'lender',
    senderId: 101,
    senderName: 'Sarah Johnson',
    senderCompany: 'First National Bank',
    senderAvatar: 'SJ',
    message: 'Hi Michael! We received the application and are currently reviewing the documentation. Should have an initial decision by end of day.',
    timestamp: '2024-01-20T10:30:00',
    isRead: true,
    attachments: []
  },
  {
    id: 3,
    loanId: 1,
    threadId: 'general',
    messageType: 'system',
    systemEventType: 'lock',
    message: 'Rate locked at 6.875% for 30 days',
    metadata: {
      rate: 6.875,
      lockPeriod: 30,
      expirationDate: '2024-02-15',
      confirmation: 'LOCK-2024-001-ABC123'
    },
    timestamp: '2024-01-20T14:30:00',
    isRead: true
  },
  {
    id: 4,
    loanId: 1,
    threadId: 'general',
    messageType: 'user',
    senderType: 'broker',
    senderId: 2,
    senderName: 'Michael Chen',
    senderAvatar: 'MC',
    message: 'Perfect! I locked the rate at 6.875%. Borrower is happy with this rate.',
    timestamp: '2024-01-20T14:35:00',
    isRead: true,
    attachments: []
  },
  {
    id: 5,
    loanId: 1,
    threadId: 'general',
    messageType: 'user',
    senderType: 'lender',
    senderId: 101,
    senderName: 'Sarah Johnson',
    senderCompany: 'First National Bank',
    senderAvatar: 'SJ',
    message: 'Great! I see the lock confirmation. We still need the following documents to proceed:\n- Recent pay stubs (last 2 months)\n- Bank statements (last 2 months)\n- Homeowners insurance quote',
    timestamp: '2024-01-21T08:45:00',
    isRead: true,
    attachments: []
  },
  {
    id: 6,
    loanId: 1,
    threadId: 'documents',
    messageType: 'user',
    senderType: 'broker',
    senderId: 2,
    senderName: 'Michael Chen',
    senderAvatar: 'MC',
    message: 'Uploading the requested documents now. Pay stubs and bank statements attached.',
    timestamp: '2024-01-22T11:20:00',
    isRead: true,
    attachments: [
      { id: 1, name: 'paystub_jan_2024.pdf', size: 245000, type: 'application/pdf' },
      { id: 2, name: 'paystub_dec_2023.pdf', size: 238000, type: 'application/pdf' },
      { id: 3, name: 'bank_statement_jan.pdf', size: 512000, type: 'application/pdf' },
      { id: 4, name: 'bank_statement_dec.pdf', size: 498000, type: 'application/pdf' }
    ]
  },
  {
    id: 7,
    loanId: 1,
    threadId: 'documents',
    messageType: 'user',
    senderType: 'lender',
    senderId: 101,
    senderName: 'Sarah Johnson',
    senderCompany: 'First National Bank',
    senderAvatar: 'SJ',
    message: 'Thanks Michael! Documents received and under review. I\'ll let you know if we need anything else.',
    timestamp: '2024-01-22T13:45:00',
    isRead: true,
    attachments: []
  },
  {
    id: 8,
    loanId: 1,
    threadId: 'general',
    messageType: 'system',
    systemEventType: 'approval',
    message: 'Loan approved with conditions',
    metadata: {
      approvalType: 'conditional',
      conditions: ['Final insurance binder', 'Appraisal review'],
      approvedBy: 'Sarah Johnson',
      approvedDate: '2024-01-23T16:00:00'
    },
    timestamp: '2024-01-23T16:00:00',
    isRead: true
  },
  {
    id: 9,
    loanId: 1,
    threadId: 'general',
    messageType: 'user',
    senderType: 'lender',
    senderId: 101,
    senderName: 'Sarah Johnson',
    senderCompany: 'First National Bank',
    senderAvatar: 'SJ',
    message: 'Excellent news! The loan has been approved with conditions. We just need:\n1. Final homeowners insurance binder\n2. Appraisal review (scheduled for next week)\n\nOnce we have these, we can move to Clear to Close.',
    timestamp: '2024-01-23T16:05:00',
    isRead: true,
    attachments: [
      { id: 5, name: 'conditional_approval_letter.pdf', size: 156000, type: 'application/pdf' }
    ]
  },
  {
    id: 10,
    loanId: 1,
    threadId: 'general',
    messageType: 'user',
    senderType: 'broker',
    senderId: 2,
    senderName: 'Michael Chen',
    senderAvatar: 'MC',
    message: 'Fantastic! I\'ll reach out to the borrower right away. The insurance binder should be ready by tomorrow.',
    timestamp: '2024-01-23T16:30:00',
    isRead: true,
    attachments: []
  },
  {
    id: 11,
    loanId: 1,
    threadId: 'insurance',
    messageType: 'user',
    senderType: 'broker',
    senderId: 2,
    senderName: 'Michael Chen',
    senderAvatar: 'MC',
    message: 'Insurance binder received from borrower. Attaching now.',
    timestamp: '2024-01-24T14:20:00',
    isRead: true,
    attachments: [
      { id: 6, name: 'insurance_binder_final.pdf', size: 324000, type: 'application/pdf' }
    ]
  },
  {
    id: 12,
    loanId: 1,
    threadId: 'insurance',
    messageType: 'user',
    senderType: 'lender',
    senderId: 101,
    senderName: 'Sarah Johnson',
    senderCompany: 'First National Bank',
    senderAvatar: 'SJ',
    message: 'Perfect! Insurance binder looks good. Waiting on appraisal now.',
    timestamp: '2024-01-24T15:10:00',
    isRead: true,
    attachments: []
  },
  {
    id: 13,
    loanId: 1,
    threadId: 'general',
    messageType: 'system',
    systemEventType: 'ctc',
    message: 'Loan cleared to close',
    metadata: {
      ctcDate: '2024-01-26T10:00:00',
      closingDate: '2024-02-05',
      clearedBy: 'Sarah Johnson'
    },
    timestamp: '2024-01-26T10:00:00',
    isRead: false
  },
  {
    id: 14,
    loanId: 1,
    threadId: 'general',
    messageType: 'user',
    senderType: 'lender',
    senderId: 101,
    senderName: 'Sarah Johnson',
    senderCompany: 'First National Bank',
    senderAvatar: 'SJ',
    message: '🎉 Great news! The loan is now Clear to Close! Appraisal came back at value. Closing is scheduled for February 5th. I\'ll send the closing disclosure shortly.',
    timestamp: '2024-01-26T10:05:00',
    isRead: false,
    attachments: []
  },
  {
    id: 15,
    loanId: 1,
    threadId: 'general',
    messageType: 'user',
    senderType: 'broker',
    senderId: 2,
    senderName: 'Michael Chen',
    senderAvatar: 'MC',
    message: 'Excellent! The borrower will be thrilled. Thank you for all your help throughout this process, Sarah!',
    timestamp: '2024-01-26T11:30:00',
    isRead: false,
    attachments: []
  }
];

// Chat Threads (for organizing conversations)
export const mockChatThreads = [
  {
    id: 'general',
    loanId: 1,
    name: 'General Discussion',
    description: 'Main conversation thread',
    icon: 'ti-message-circle',
    messageCount: 8,
    unreadCount: 2,
    lastMessage: 'Excellent! The borrower will be thrilled...',
    lastMessageTime: '2024-01-26T11:30:00'
  },
  {
    id: 'documents',
    loanId: 1,
    name: 'Documents',
    description: 'Document-related discussions',
    icon: 'ti-file-text',
    messageCount: 2,
    unreadCount: 0,
    lastMessage: 'Thanks Michael! Documents received...',
    lastMessageTime: '2024-01-22T13:45:00'
  },
  {
    id: 'insurance',
    loanId: 1,
    name: 'Insurance',
    description: 'Insurance binder discussions',
    icon: 'ti-shield-check',
    messageCount: 2,
    unreadCount: 0,
    lastMessage: 'Perfect! Insurance binder looks good...',
    lastMessageTime: '2024-01-24T15:10:00'
  }
];

// Borrower Portal Access (for authentication)
export const mockBorrowerAccess = [
  {
    loanId: 1,
    loanNumber: 'UFF-2024-001',
    borrowerLastSSN: '1234',
    borrowerName: 'John Smith',
    borrowerEmail: 'john.smith@email.com',
    accessToken: 'abc123xyz789',
    expiresAt: '2026-12-31T23:59:59',
    generatedBy: 'Michael Chen',
    generatedAt: '2024-01-20T09:00:00'
  }
];

// AI Analysis Results (Virtual Underwriter)
export const mockAIAnalysis = {
  loanId: 1,
  analysisDate: '2024-01-26T14:30:00',
  analysisVersion: '2.1.0',
  overallRiskScore: 72,
  riskLevel: 'moderate',
  riskFlags: [
    {
      id: 1,
      severity: 'high',
      category: 'DTI',
      flag: 'Debt-to-Income Ratio Near Limit',
      description: 'DTI at 42% is approaching the 43% conventional limit. Any additional debt could disqualify the borrower.',
      recommendation: 'Consider paying down credit card balances before closing or explore FHA options with higher DTI tolerance.',
      impact: 'Could affect loan approval if additional debts are discovered'
    },
    {
      id: 2,
      severity: 'medium',
      category: 'Credit',
      flag: 'Recent Credit Inquiry',
      description: 'Hard inquiry from auto dealer 45 days ago. Borrower may have new auto loan not yet reported.',
      recommendation: 'Request updated credit report and verify no new debt obligations were incurred.',
      impact: 'New auto loan could increase DTI and affect qualification'
    },
    {
      id: 3,
      severity: 'low',
      category: 'Employment',
      flag: 'Employment Gap in History',
      description: '3-month gap between previous and current employer. Gap is explained but may require additional documentation.',
      recommendation: 'Obtain letter of explanation and verify no unreported income loss during gap period.',
      impact: 'Minor documentation requirement, unlikely to affect approval'
    },
    {
      id: 4,
      severity: 'medium',
      category: 'Assets',
      flag: 'Large Recent Deposit',
      description: '$15,000 deposit in checking account 30 days ago. Source not yet documented.',
      recommendation: 'Obtain documentation for deposit source (gift letter, sale proceeds, etc.). If gift, ensure proper seasoning requirements are met.',
      impact: 'Could affect cash-to-close calculation if not properly sourced'
    }
  ],
  improvementSuggestions: [
    {
      id: 1,
      category: 'Rate Optimization',
      suggestion: 'Consider 15-Year Term for Lower Rate',
      description: 'Borrower qualifies for 15-year term with 0.625% lower rate. Monthly payment increases by $890 but saves $372,600 in total interest.',
      potentialBenefit: 'Save $372,600 over loan life',
      tradeoff: 'Higher monthly payment (+$890)',
      feasibility: 'high'
    },
    {
      id: 2,
      category: 'Cost Reduction',
      suggestion: 'Increase Down Payment to Eliminate PMI',
      description: 'Borrower is at 90% LTV with $225/mo PMI. Increasing down payment by $50,000 to reach 80% LTV eliminates PMI.',
      potentialBenefit: 'Save $225/month ($81,000 over 30 years)',
      tradeoff: 'Requires additional $50,000 upfront',
      feasibility: 'medium'
    },
    {
      id: 3,
      category: 'Approval Strength',
      suggestion: 'Pay Down Credit Cards Before Closing',
      description: 'Paying off $8,000 in credit card balances would reduce DTI from 42% to 38%, significantly strengthening the application.',
      potentialBenefit: 'Stronger approval, better rate options',
      tradeoff: 'Reduces liquid reserves by $8,000',
      feasibility: 'high'
    },
    {
      id: 4,
      category: 'Documentation',
      suggestion: 'Obtain VOE Early',
      description: 'Request Verification of Employment now rather than waiting. Reduces closing timeline risk.',
      potentialBenefit: 'Faster closing, reduced risk of last-minute delays',
      tradeoff: 'None',
      feasibility: 'high'
    }
  ],
  alternativeStrategies: [
    {
      id: 1,
      strategy: 'FHA Loan with Lower Down Payment',
      description: 'Switch to FHA loan with 3.5% down instead of 10% conventional. Frees up $32,500 in cash.',
      pros: [
        'Lower down payment requirement',
        'Higher DTI tolerance (up to 50%)',
        'More flexible credit requirements',
        'Preserves cash reserves'
      ],
      cons: [
        'Requires mortgage insurance for life of loan',
        'Slightly higher interest rate (+0.125%)',
        'Upfront mortgage insurance premium (1.75%)',
        'Lower loan limits in some areas'
      ],
      estimatedSavings: '$32,500 cash preserved',
      recommendationScore: 75
    },
    {
      id: 2,
      strategy: 'ARM Instead of Fixed Rate',
      description: 'Use 7/1 ARM at 6.250% instead of 30-year fixed at 6.875%. Save $155/month for first 7 years.',
      pros: [
        'Lower initial rate (6.250% vs 6.875%)',
        'Lower monthly payment ($155/month savings)',
        'Fixed for 7 years (likely refinance before adjustment)',
        'Total savings of $13,020 over 7 years'
      ],
      cons: [
        'Rate can adjust after 7 years',
        'Payment uncertainty after fixed period',
        'May not be suitable if planning to stay long-term',
        'Caps limit but don\'t eliminate risk'
      ],
      estimatedSavings: '$13,020 over 7 years',
      recommendationScore: 65
    },
    {
      id: 3,
      strategy: 'Delay Closing 60 Days',
      description: 'Wait 60 days to season the $15,000 deposit and obtain updated credit report showing no new debt.',
      pros: [
        'Eliminates large deposit documentation requirement',
        'Confirms no new auto loan from recent inquiry',
        'Strengthens overall application',
        'May qualify for better rate with stronger profile'
      ],
      cons: [
        'Delays home purchase by 2 months',
        'Risk of rate increase during wait period',
        'Current rate lock expires',
        'Seller may not agree to extension'
      ],
      estimatedSavings: 'Risk mitigation',
      recommendationScore: 45
    }
  ],
  confidenceScore: 87,
  analysisNotes: 'Overall strong application with manageable risk factors. Primary concerns are DTI proximity to limits and undocumented deposit. Recommend addressing credit card balances and large deposit documentation before proceeding. Borrower has multiple viable paths to approval.',
  disclaimer: 'This AI analysis is advisory only and does not constitute an underwriting decision. All recommendations must be reviewed and approved by a licensed underwriter. Actual loan approval is subject to complete documentation review and lender guidelines.'
};

// Mock Broker Users (for Broker Admin user management)
export const mockBrokerUsers = [
  {
    id: 2,
    name: 'Michael Chen',
    email: 'michael@primemortgage.com',
    nmls: '123456',
    officeId: 1,
    officeName: 'Main Office - Los Angeles',
    role: 'BrokerAdmin',
    loginType: 'Both',
    status: 'Active',
    createdDate: '2024-01-15'
  },
  {
    id: 3,
    name: 'Jennifer Martinez',
    email: 'jennifer@primemortgage.com',
    nmls: '789012',
    officeId: 1,
    officeName: 'Main Office - Los Angeles',
    role: 'BrokerUser',
    loginType: 'Password',
    status: 'Active',
    createdDate: '2024-01-20'
  },
  {
    id: 5,
    name: 'Robert Johnson',
    email: 'robert@primemortgage.com',
    nmls: '456789',
    officeId: 2,
    officeName: 'Satellite Office - San Diego',
    role: 'BrokerUser',
    loginType: 'Federated',
    status: 'Active',
    createdDate: '2024-02-01'
  },
  {
    id: 6,
    name: 'Lisa Anderson',
    email: 'lisa@primemortgage.com',
    nmls: '234567',
    officeId: 1,
    officeName: 'Main Office - Los Angeles',
    role: 'BrokerUser',
    loginType: 'Both',
    status: 'Disabled',
    createdDate: '2024-01-25'
  }
];

// COC (Change of Circumstance) Categories - TRID Compliant
export const cocCategories = [
  {
    id: 'changed-borrower-info',
    name: 'Changed Borrower Information',
    description: 'Changes to borrower income, assets, credit, or personal information',
    complianceNote: 'Must be borrower-initiated or discovered through verification'
  },
  {
    id: 'borrower-loan-term-change',
    name: 'Borrower-Requested Loan Term Change',
    description: 'Borrower requests different loan amount, term, or program',
    complianceNote: 'Must be documented borrower request'
  },
  {
    id: 'property-related-change',
    name: 'Property-Related Change',
    description: 'Appraisal value, property condition, or title issues',
    complianceNote: 'Must be discovered after initial disclosure'
  },
  {
    id: 'third-party-fee-change',
    name: 'Third-Party Fee Change (Beyond Control)',
    description: 'Fees from third parties that changed beyond lender control',
    complianceNote: 'Must be from unaffiliated third party'
  },
  {
    id: 'rate-lock-extension',
    name: 'Rate Lock / Lock Extension',
    description: 'Rate lock expiration or extension request',
    complianceNote: 'Must be due to changed circumstance or borrower delay'
  },
  {
    id: 'borrower-caused-delay',
    name: 'Borrower-Caused Delay',
    description: 'Delays caused by borrower actions or inactions',
    complianceNote: 'Must document specific borrower actions causing delay'
  },
  {
    id: 'extraordinary-event',
    name: 'Extraordinary / Unforeseeable Event',
    description: 'Natural disaster, emergency, or other unforeseeable circumstances',
    complianceNote: 'Must be truly unforeseeable at time of initial disclosure'
  }
];

// COC Impacted Elements
export const cocImpactedElements = [
  { id: 'loan-amount', name: 'Loan Amount' },
  { id: 'interest-rate', name: 'Interest Rate / Lock Status' },
  { id: 'program-term', name: 'Program / Term' },
  { id: 'appraised-value', name: 'Appraised Value' },
  { id: 'third-party-fees', name: 'Third-Party Fees' },
  { id: 'closing-date', name: 'Timeline / Closing Date' }
];

// Mock COC Requests
export const mockCOCRequests = [
  {
    id: 1,
    loanId: 1,
    loanNumber: 'UFF-2024-001',
    category: 'property-related-change',
    categoryName: 'Property-Related Change',
    description: 'Appraisal came in $15,000 lower than expected purchase price. Borrower needs to increase down payment or adjust loan amount.',
    discoveryDate: '2026-02-01',
    reasonNotKnown: 'Appraisal was not completed until after initial disclosure. Property condition issues were discovered during inspection that affected value.',
    impactedElements: ['loan-amount', 'appraised-value'],
    supportingDocuments: [
      {
        id: 1,
        fileName: 'appraisal_report_123_oak_st.pdf',
        fileSize: '2.4 MB',
        uploadDate: '2026-02-01T14:30:00',
        label: 'Appraisal Report'
      },
      {
        id: 2,
        fileName: 'inspection_report.pdf',
        fileSize: '1.8 MB',
        uploadDate: '2026-02-01T14:32:00',
        label: 'Property Inspection'
      }
    ],
    attestation: true,
    attestationText: 'I attest that this change represents a valid Change of Circumstance under TRID regulations, was not known or reasonably foreseeable at the time of initial disclosure, and is supported by the attached documentation.',
    submittedBy: 'Michael Chen',
    submittedDate: '2026-02-01T14:35:00',
    status: 'Approved',
    reviewedBy: 'Sarah Johnson',
    reviewedDate: '2026-02-02T09:15:00',
    reviewNotes: 'Valid COC. Appraisal value change was unforeseeable. Revised LE issued.',
    revisedDisclosureIssued: true,
    revisedDisclosureDate: '2026-02-02T10:00:00'
  },
  {
    id: 2,
    loanId: 1,
    loanNumber: 'UFF-2024-001',
    category: 'rate-lock-extension',
    categoryName: 'Rate Lock / Lock Extension',
    description: 'Rate lock expires 2/20/2026. Borrower has not provided final employment verification despite multiple requests. Need to extend lock.',
    discoveryDate: '2026-02-03',
    reasonNotKnown: 'Borrower delay in providing documentation was not anticipated at initial disclosure. Multiple follow-ups have been documented.',
    impactedElements: ['interest-rate', 'closing-date'],
    supportingDocuments: [
      {
        id: 3,
        fileName: 'borrower_communication_log.pdf',
        fileSize: '456 KB',
        uploadDate: '2026-02-03T11:20:00',
        label: 'Communication Log'
      },
      {
        id: 4,
        fileName: 'lock_extension_quote.pdf',
        fileSize: '234 KB',
        uploadDate: '2026-02-03T11:22:00',
        label: 'Lock Extension Quote'
      }
    ],
    attestation: true,
    attestationText: 'I attest that this change represents a valid Change of Circumstance under TRID regulations, was not known or reasonably foreseeable at the time of initial disclosure, and is supported by the attached documentation.',
    submittedBy: 'Michael Chen',
    submittedDate: '2026-02-03T11:25:00',
    status: 'Under Review',
    reviewedBy: null,
    reviewedDate: null,
    reviewNotes: null,
    revisedDisclosureIssued: false,
    revisedDisclosureDate: null
  }
];
